import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Dictionary } from '@ngrx/entity/src/models';
import * as GuidelinesNotSavedChangesActions from './guidelines-not-saved-changes.actions';
import * as GuidelinesNotSavedChangesSelectors from './guidelines-not-saved-changes.selectors';
import { GuidelinesNotSavedChangesEntity } from './guidelines-not-saved-changes.reducer';

@Injectable()
export class GuidelinesNotSavedChangesFacade {
  constructor(private readonly store: Store) {}

  public addPartPricingChangesToStore(partPricingState: GuidelinesNotSavedChangesEntity): void {
    this.store.dispatch(GuidelinesNotSavedChangesActions.updateNotSavedPartPricingState(partPricingState));
  }

  public getGuidelinesChanges(): Observable<Dictionary<GuidelinesNotSavedChangesEntity>> {
    return this.store.pipe(select(GuidelinesNotSavedChangesSelectors.getGuidelinesNotSavedChangesEntities()));
  }

  public clearAllChanges(): void {
    this.store.dispatch(GuidelinesNotSavedChangesActions.removeAllNotSavedChanges());
  }

  public clearChangesByCountryId(countryId: string): void {
    this.store.dispatch(GuidelinesNotSavedChangesActions.removeNotSavedChangesByCountryId({ countryId }));
  }
}
